// @ts-nocheck
import * as React from "react";

const ExternalLink: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 3a1 1 0 1 1 0 2H6a1 1 0 0 0-1 1v12l.007.117A1 1 0 0 0 6 19h12a1 1 0 0 0 1-1v-6l.007-.117A1 1 0 0 1 20 11l.117.007A1 1 0 0 1 21 12v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6l.005-.176A3 3 0 0 1 6 3Zm8 0a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1l-.117-.007A1 1 0 0 1 19 8V6.42l-6.29 6.28a1.002 1.002 0 0 1-1.42 0 1.002 1.002 0 0 1 0-1.42L17.58 5H16a1 1 0 1 1 0-2Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ExternalLink);
